import React from "react";
import {css, Theme} from "@emotion/react";

import {Accordion} from "@pg-design/accordion-module";
import {Badge} from "@pg-design/badge-module";
import {backgroundColor, calculateRemSize, flex, flexDirection, mr, p, pb, ph} from "@pg-design/helpers-css";
import {form, IFormProps} from "@pg-mono/form";

import {Currency} from "../../types/Currency";
import {ISearchFilters} from "../types/ISearchFilters";
import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";
import {FilterFooter} from "./filters/SearchFiltersFooter";
import {FilterForm} from "./generic_filters/FilterForm";
import {GenericFilter} from "./generic_filters/GenericFilter";

interface IOwnProps<TSearchFiltersForm extends {}> {
    searchFiltersConfig: ISearchFilters<TSearchFiltersForm>;
    searchFiltersCountBySlots?: Record<string, number>;
    onClose?: () => void;
    onResetForm?: () => void;
    footerClearButtonText?: string;
    footerSubmitButtonText?: string;
    isNotificationsSubscriptionModal?: boolean;
    currency?: Currency;
}

interface IProps extends IOwnProps<ISearchFiltersFormValues>, IFormProps<ISearchFiltersFormValues> {}

const SearchFiltersWithAccordionC = (props: IProps) => {
    const onClose = () => {
        props.onClose && props.onClose();
    };

    const submit = (e: React.MouseEvent<HTMLElement>) => {
        onClose();
        props.onSubmit && props.onSubmit(e);
    };

    const setInitialOpen = (filter: string) => {
        switch (filter) {
            case "price":
                return props.values[filter].upper === "" && !props.values.instalment;
            case "rooms":
                return props.values[filter].upper === "";
            default:
                return false;
        }
    };

    return (
        <div css={filtersHolder}>
            <div css={[filtersScroller, props.isNotificationsSubscriptionModal && filtersSubscriptionStyle]}>
                {props.searchFiltersConfig.slots.map((filterSlot) => (
                    <Accordion key={filterSlot.id} initiallyExpanded={setInitialOpen(filterSlot.id)} theme="white">
                        <Accordion.Header>
                            <div css={filterHeaderTextStyle}>{filterSlot.label}</div>
                            {props.searchFiltersCountBySlots?.[filterSlot.id] ? (
                                <Badge variant="label_danger" css={filtersCountBadge}>
                                    {props.searchFiltersCountBySlots?.[filterSlot.id]}
                                </Badge>
                            ) : null}
                        </Accordion.Header>
                        <Accordion.Content css={[pb(0.5)]}>
                            <FilterForm defaultValues={props.values}>
                                {filterSlot.filters.map((filter) => (
                                    <GenericFilter key={filter.id as string} filter={filter} {...props.getFieldProps(filter.id)} currency={props.currency} />
                                ))}
                            </FilterForm>
                        </Accordion.Content>
                    </Accordion>
                ))}

                <div css={[filterFooterWrapper]}>
                    <FilterFooter
                        onCancel={props.onResetForm || (() => null)}
                        onSave={(e: React.MouseEvent<HTMLElement>) => {
                            submit(e);
                        }}
                        clearText={props.footerClearButtonText}
                        submitText={props.footerSubmitButtonText}
                    />
                </div>
            </div>
        </div>
    );
};

export const SearchFiltersWithAccordion = form<ISearchFiltersFormValues, IProps>(SearchFiltersWithAccordionC);

const filtersHolder = css`
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex-basis: 100%;
`;

const filtersScroller = css`
    ${flex()};
    ${flexDirection("column")};
    ${p(2, 2, 0, 2)};
    gap: ${calculateRemSize(2)};
    flex: 1 1 auto;
    overflow: auto;
`;

const filtersSubscriptionStyle = (theme: Theme) => css`
    @media (min-width: ${theme.breakpoints.md}) {
        min-height: 566px;
        ${ph(0)};

        > div {
            ${ph(0)};
            ${pb(0)};
        }
    }
`;

const filterFooterWrapper = (theme: Theme) => css`
    ${p(2)};
    flex: 0 0;
    position: sticky;
    bottom: 0;
    ${backgroundColor(theme.colors.background["100"])};
    margin-bottom: -${calculateRemSize(2)};
    z-index: 11;
`;

const filterHeaderTextStyle = css`
    flex: 1 1 100%;
`;

const filtersCountBadge = css`
    flex: 0 0 auto;
    justify-self: flex-end;
    justify-content: center;
    ${mr(2)};
    padding: 0.5rem; // override default badge width
    min-width: 2.2rem; // override default badge width
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {Accordion} from "@pg-design/accordion-module";
import {Badge} from "@pg-design/badge-module";
import {backgroundColor, calculateRemSize, flex, flexDirection, mr, p, pb, ph} from "@pg-design/helpers-css";
import {form, IFormProps} from "@pg-mono/form";

import {Currency} from "../../types/Currency";
import {ISearchFilters} from "../types/ISearchFilters";
import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";
import {FilterFooter} from "./filters/SearchFiltersFooter";
import {FilterForm} from "./generic_filters/FilterForm";
import {GenericFilter} from "./generic_filters/GenericFilter";

interface IOwnProps<TSearchFiltersForm extends {}> {
    searchFiltersConfig: ISearchFilters<TSearchFiltersForm>;
    searchFiltersCountBySlots?: Record<string, number>;
    onClose?: () => void;
    onResetForm?: () => void;
    footerClearButtonText?: string;
    footerSubmitButtonText?: string;
    isNotificationsSubscriptionModal?: boolean;
    currency?: Currency;
}

interface IProps extends IOwnProps<ISearchFiltersFormValues>, IFormProps<ISearchFiltersFormValues> {}

const SearchFiltersWithAccordionC = (props: IProps) => {
    const onClose = () => {
        props.onClose && props.onClose();
    };

    const submit = (e: React.MouseEvent<HTMLElement>) => {
        onClose();
        props.onSubmit && props.onSubmit(e);
    };

    const setInitialOpen = (filter: string) => {
        switch (filter) {
            case "price":
                return props.values[filter].upper === "" && !props.values.instalment;
            case "rooms":
                return props.values[filter].upper === "";
            default:
                return false;
        }
    };

    return (
        <div css={filtersHolder}>
            <div css={[filtersScroller, props.isNotificationsSubscriptionModal && filtersSubscriptionStyle]}>
                {props.searchFiltersConfig.slots.map((filterSlot) => (
                    <Accordion key={filterSlot.id} initiallyExpanded={setInitialOpen(filterSlot.id)} theme="white">
                        <Accordion.Header>
                            <div css={filterHeaderTextStyle}>{filterSlot.label}</div>
                            {props.searchFiltersCountBySlots?.[filterSlot.id] ? (
                                <Badge variant="label_danger" css={filtersCountBadge}>
                                    {props.searchFiltersCountBySlots?.[filterSlot.id]}
                                </Badge>
                            ) : null}
                        </Accordion.Header>
                        <Accordion.Content css={[pb(0.5)]}>
                            <FilterForm defaultValues={props.values}>
                                {filterSlot.filters.map((filter) => (
                                    <GenericFilter key={filter.id as string} filter={filter} {...props.getFieldProps(filter.id)} currency={props.currency} />
                                ))}
                            </FilterForm>
                        </Accordion.Content>
                    </Accordion>
                ))}

                <div css={[filterFooterWrapper]}>
                    <FilterFooter
                        onCancel={props.onResetForm || (() => null)}
                        onSave={(e: React.MouseEvent<HTMLElement>) => {
                            submit(e);
                        }}
                        clearText={props.footerClearButtonText}
                        submitText={props.footerSubmitButtonText}
                    />
                </div>
            </div>
        </div>
    );
};

export const SearchFiltersWithAccordion = form<ISearchFiltersFormValues, IProps>(SearchFiltersWithAccordionC);

const filtersHolder = css`
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex-basis: 100%;
`;

const filtersScroller = css`
    ${flex()};
    ${flexDirection("column")};
    ${p(2, 2, 0, 2)};
    gap: ${calculateRemSize(2)};
    flex: 1 1 auto;
    overflow: auto;
`;

const filtersSubscriptionStyle = (theme: Theme) => css`
    @media (min-width: ${theme.breakpoints.md}) {
        min-height: 566px;
        ${ph(0)};

        > div {
            ${ph(0)};
            ${pb(0)};
        }
    }
`;

const filterFooterWrapper = (theme: Theme) => css`
    ${p(2)};
    flex: 0 0;
    position: sticky;
    bottom: 0;
    ${backgroundColor(theme.colors.background["100"])};
    margin-bottom: -${calculateRemSize(2)};
    z-index: 11;
`;

const filterHeaderTextStyle = css`
    flex: 1 1 100%;
`;

const filtersCountBadge = css`
    flex: 0 0 auto;
    justify-self: flex-end;
    justify-content: center;
    ${mr(2)};
    padding: 0.5rem; // override default badge width
    min-width: 2.2rem; // override default badge width
`;
